/* ================================================================
   THE ROAR COMPANY — Theme v2 | theme.js
   Clean, purposeful interactions only.
   ================================================================ */

(function () {
  'use strict';

  /* ── Sticky Promo Bar ─────────────────────────────────────── */
  const promoBar = document.querySelector('.promo-bar');
  const promoClose = document.querySelector('.promo-bar__close');
  let promoDismissed = sessionStorage.getItem('promo_dismissed') === '1';
  let lastScrollY = 0;

  if (promoBar && promoClose) {
    promoClose.addEventListener('click', () => {
      promoBar.classList.remove('visible');
      document.body.classList.remove('promo-visible');
      promoDismissed = true;
      sessionStorage.setItem('promo_dismissed', '1');
    });

    window.addEventListener('scroll', () => {
      const sy = window.scrollY;
      if (!promoDismissed && sy > 500 && sy < lastScrollY) {
        promoBar.classList.add('visible');
        document.body.classList.add('promo-visible');
      } else if (sy <= 100 || sy > lastScrollY + 20) {
        promoBar.classList.remove('visible');
        document.body.classList.remove('promo-visible');
      }
      lastScrollY = sy;
    }, { passive: true });
  }

  /* ── Mobile Nav ─────────────────────────────────────────── */
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavToggle = document.getElementById('mobile-nav-toggle');
  const mobileNavClose = document.getElementById('mobile-nav-close');
  const mobileNavOverlay = document.getElementById('mobile-nav-overlay');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (mobileNavToggle) mobileNavToggle.classList.add('open');
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    document.body.style.overflow = '';
    if (mobileNavToggle) mobileNavToggle.classList.remove('open');
  }

  if (mobileNavToggle) mobileNavToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMobileNav(); });

  /* Mobile Products Submenu */
  const mobileProductsToggle = document.querySelector('.mobile-nav__products-toggle');
  const mobileSubcats = document.querySelector('.mobile-nav__subcats');
  if (mobileProductsToggle && mobileSubcats) {
    mobileProductsToggle.addEventListener('click', () => {
      mobileProductsToggle.classList.toggle('open');
      mobileSubcats.classList.toggle('open');
    });
  }

  /* ── Header Scroll ──────────────────────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mega Menu ─────────────────────────────────────────── */
  const megaTab = document.querySelector('.nav-tab--products');
  let megaTimeout;
  if (megaTab) {
    megaTab.addEventListener('mouseenter', () => { clearTimeout(megaTimeout); megaTab.classList.add('open'); });
    megaTab.addEventListener('mouseleave', () => { megaTimeout = setTimeout(() => megaTab.classList.remove('open'), 250); });
    const megaMenu = megaTab.querySelector('.mega-menu');
    if (megaMenu) {
      megaMenu.addEventListener('mouseenter', () => clearTimeout(megaTimeout));
      megaMenu.addEventListener('mouseleave', () => { megaTimeout = setTimeout(() => megaTab.classList.remove('open'), 250); });
    }
  }

  /* ── Cart Count ─────────────────────────────────────────── */
  function updateCartCount(count) {
    const badge = document.querySelector('.header-cart__count');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('visible', count > 0);
  }
  fetch('/cart.js').then(r => r.json()).then(c => updateCartCount(c.item_count)).catch(() => {});

  /* ── Toast ──────────────────────────────────────────────── */
  const toast = document.getElementById('cart-toast');
  const toastMsg = document.getElementById('cart-toast-message');
  let toastTimer;
  function showToast(message, isError) {
    if (!toast) return;
    if (toastMsg) toastMsg.textContent = message;
    toast.classList.toggle('toast--error', !!isError);
    toast.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('visible'), 3000);
  }

  /* ── AJAX Add to Cart ───────────────────────────────────── */
  async function addToCart(variantId, quantity, button) {
    if (!button) return;
    button.disabled = true;
    const orig = button.innerHTML;
    button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="spin"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || 'Could not add item');
      const cart = await fetch('/cart.js').then(r => r.json());
      updateCartCount(cart.item_count);
      showToast('Added to cart!');
    } catch (err) {
      showToast(err.message || 'Something went wrong', true);
    } finally {
      button.disabled = false;
      button.innerHTML = orig;
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.variantId) addToCart(btn.dataset.variantId, 1, btn);
  });

  /* ── Scroll Reveal ──────────────────────────────────────── */
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.fade-up, .reveal').forEach(el => revealObs.observe(el));

  /* ── Stats Counter ──────────────────────────────────────── */
  function animateCount(el, target) {
    const suffix = el.dataset.suffix || '';
    const prefix = el.dataset.prefix || '';
    const start = performance.now();
    const duration = 1600;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 4);
      el.textContent = prefix + Math.round(eased * target).toLocaleString('en-IN') + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  const statsObs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const t = parseInt(entry.target.dataset.count || 0);
        if (t) animateCount(entry.target, t);
        statsObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('[data-count]').forEach(el => statsObs.observe(el));

  /* ── Product Page ───────────────────────────────────────── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    const variantInput = productForm.querySelector('[name="id"]');
    const priceEl = document.getElementById('product-price');
    const compareEl = document.getElementById('product-compare');
    const addBtn = document.getElementById('add-to-cart-btn');

    productForm.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const option = btn.closest('.variant-options');
        option.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const selectedOptions = Array.from(productForm.querySelectorAll('.variant-options'))
          .map(o => o.querySelector('.variant-btn.active')?.dataset.value).filter(Boolean);
        const variants = JSON.parse(productForm.dataset.variants || '[]');
        const match = variants.find(v => v.options.every((o, i) => o === selectedOptions[i]));
        if (match && variantInput) {
          variantInput.value = match.id;
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          if (compareEl) compareEl.textContent = match.compare_at_price > match.price ? formatMoney(match.compare_at_price) : '';
          if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out'; }
        }
      });
    });

    const qtyInput = productForm.querySelector('.qty-control__input');
    productForm.querySelector('.qty-dec')?.addEventListener('click', () => { if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1; });
    productForm.querySelector('.qty-inc')?.addEventListener('click', () => { if (qtyInput) qtyInput.value = parseInt(qtyInput.value || 1) + 1; });

    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const id = variantInput?.value;
      if (id) await addToCart(id, parseInt(qtyInput?.value || 1), addBtn);
    });

    const mainImg = document.getElementById('gallery-main-img');
    document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImg) { mainImg.src = thumb.dataset.src; mainImg.srcset = thumb.dataset.srcset || ''; }
      });
    });

    document.querySelectorAll('.accordion-trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.accordion-item');
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ── Cart Page ──────────────────────────────────────────── */
  document.querySelectorAll('[data-cart-remove]').forEach(btn => {
    btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.cartRemove, quantity: 0 }) });
      window.location.reload();
    });
  });
  document.querySelectorAll('[data-cart-qty]').forEach(input => {
    input.addEventListener('change', async () => {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: input.dataset.cartQty, quantity: parseInt(input.value) }) });
      window.location.reload();
    });
  });

  /* ── Newsletter ─────────────────────────────────────────── */
  document.querySelectorAll('[data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn = form.querySelector('button[type="submit"]');
      const msg = form.querySelector('[data-newsletter-msg]');
      if (!input?.value) return;
      if (btn) { btn.disabled = true; btn.textContent = '...'; }
      try {
        await fetch(form.action, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams(new FormData(form)) });
        if (msg) { msg.textContent = 'Thank you! You\'re on the list.'; msg.style.color = 'var(--forest)'; }
        input.value = '';
      } catch { if (msg) { msg.textContent = 'Something went wrong.'; msg.style.color = '#c0392b'; } }
      finally { if (btn) { btn.disabled = false; btn.textContent = 'Subscribe'; } }
    });
  });

  /* ── Waitlist ────────────────────────────────────────────── */
  document.querySelectorAll('[data-waitlist-form]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = '...'; }
      setTimeout(() => { form.innerHTML = '<p style="color:var(--amber-2);font-family:var(--font-heading);font-weight:700;font-size:15px;">You\'re on the list! We\'ll notify you when it\'s ready.</p>'; }, 800);
    });
  });

  function formatMoney(cents) { return '₹' + (cents / 100).toLocaleString('en-IN'); }

})();
